var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgUpload(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.0501 6.9502C1.4367 6.9502 1.7501 7.2636 1.7501 7.6502V9.8502C1.7501 9.95636 1.79226 10.0581 1.86727 10.1331C1.94218 10.208 2.04387 10.2502 2.1501 10.2502H9.85011C9.9563 10.2502 10.058 10.208 10.1329 10.1331C10.2079 10.0581 10.2501 9.95636 10.2501 9.8502V7.6502C10.2501 7.2636 10.5635 6.9502 10.9501 6.9502C11.3367 6.9502 11.6501 7.2636 11.6501 7.6502V9.8502C11.6501 10.3276 11.4605 10.7855 11.1229 11.1231C10.7852 11.4607 10.3273 11.6502 9.85011 11.6502H2.1501C1.67285 11.6502 1.21497 11.4607 0.877301 11.1231C0.539737 10.7855 0.350098 10.3276 0.350098 9.8502V7.6502C0.350098 7.2636 0.663498 6.9502 1.0501 6.9502Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.49478 0.555123C6.22141 0.281756 5.7782 0.281756 5.50483 0.555123L2.75483 3.30512C2.48146 3.57849 2.48146 4.02171 2.75483 4.29507C3.0282 4.56844 3.47141 4.56844 3.74478 4.29507L5.2998 2.74005V7.65005C5.2998 8.03665 5.61321 8.35005 5.9998 8.35005C6.3864 8.35005 6.6998 8.03665 6.6998 7.65005V2.74005L8.25483 4.29507C8.5282 4.56844 8.97141 4.56844 9.24478 4.29507C9.51815 4.02171 9.51815 3.57849 9.24478 3.30512L6.49478 0.555123Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpload);
export default __webpack_public_path__ + "static/media/Upload.e10365bf2f189076d4e6796c576befc9.svg";
export { ForwardRef as ReactComponent };